import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  // Keep this failure obvious during development.
  throw new Error('Missing Supabase environment variables.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const withCacheBuster = (url) => {
  if (!url) return ''
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}v=${Date.now()}`
}

export const isExternalAvatarUrl = (url) => {
  if (!url) return false
  const lower = String(url).toLowerCase()
  if (lower.includes('/object/sign/avatars/')) return false
  if (lower.includes('/storage/v1/object/')) return false
  if (supabaseUrl && lower.startsWith(String(supabaseUrl).toLowerCase())) return false
  return true
}

export const getAvatarUrl = ({ avatarPath, avatarUrl }) => {
  if (avatarUrl && isExternalAvatarUrl(avatarUrl)) {
    return withCacheBuster(avatarUrl)
  }

  if (avatarPath) {
    const { data } = supabase.storage.from('avatars').getPublicUrl(avatarPath)
    return withCacheBuster(data?.publicUrl || '')
  }

  if (avatarUrl && String(avatarUrl).includes('/object/sign/avatars/')) {
    const pathMatch = String(avatarUrl).match(/\/object\/sign\/avatars\/(.+?)\?/)
    if (pathMatch?.[1]) {
      const { data } = supabase.storage.from('avatars').getPublicUrl(pathMatch[1])
      return withCacheBuster(data?.publicUrl || '')
    }
  }

  return withCacheBuster(avatarUrl || '')
}
